<template>
    <section class="panel-body">
        <!-- <small><strong>Consumo mês</strong></small> -->
        <div class="row" v-if="!auth_user.cashback_enabled">
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-success elevation-1"><i class="text-light fa fa-dollar"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Meus Pontos </strong>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.points}}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-orange elevation-1"><i class="text-light fa fa-tag"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Cupons Disponíveis</strong></span>
                        <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.tickets_count || 0}}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-qrcode"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'vouchers' }">
                            <span class="info-box-text text-white"><strong>Meus Vouchers</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.vouchers_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-purple elevation-1"><i class="fa fa-file-text"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'extrato' }">
                            <span class="info-box-text "><strong>Ver Extrato</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.sales_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="auth_user.cashback_enabled">
            <div class="col-12 col-sm-6 col-md-6">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-success elevation-1"><i class="text-light fa fa-dollar"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Cashback </strong>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{ formatMoney(auth_user.cashback_value)}}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-purple elevation-1"><i class="fa fa-file-text"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'extrato' }">
                            <span class="info-box-text "><strong>Ver Extrato</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.sales_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!auth_user.cashback_enabled">
            <div class="col-md-12 mt-2">
                <div class="input-group mb-3">
                    <input class="form-control" v-model="term" placeholder="Digite aqui para consultar"
                    @keyup.enter="getDashInicial()"
                        style="text-align:center; font-size:20px; font-weight: bold;">
                    <div class="input-group-append">
                        <button @click="getDashInicial()" class="input-group-btn btn btn-secondary"><i
                                class="fa fa-search"></i> Pesquisar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!auth_user.cashback_enabled">
            <template v-for="item in tickets">
                <div class="col-md-4" :key="item.id">
                    <div class="card shadow border">
                        <img role="button" @click="incrementClickCupom(item.id)" class="card-img-top" :src="item.image"
                            alt="Card image cap">
                        <div class="card-body">
                            <h5 class="text-center text-bold pb-3">{{item.title}}</h5>
                            <p :class="{'text-hidden': !item.showDetails}" class="card-text text-center mt-n2"><span
                                    v-html="item.description"></span></p>
                            <h5 class="text-center text-danger"><span class="text-bold">{{item.value}}</span> PONTOS

                            </h5>
                            <small class="float-left">{{item.in_stock}} disponíveis</small>
                            <a role="button" @click="incrementClickCupom(item.id, item)" class="float-right">Mais
                                detalhes <i class="fa fa-angle-double-right"></i></a>
                            <button @click="buyTicket(item)" :disabled="auth_user.points < item.value || item.loading"
                                class="btn btn-success btn-block"><i class="fa fa-cart-arrow-down"></i>
                                ADQUIRIR</button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                tickets: [],
                term: null
            }
        },
        mounted() {
            this.getDashInicial();
        },
        methods: {
            getDashInicial() {
                this.$store.dispatch("getDashboard", this.term).then(response => {
                    this.tickets = response;
                });
            },
            incrementClickCupom(id, item = null) {
                if (item) {
                    item.showDetails = !item.showDetails;
                }
                this.$store.dispatch("incrementClickCupom", id).then(response => {
                }).catch(error => {                   
                }).finally(() => {
                })
            },
            async buyTicket(item) {
                const confimed = await confirm(
                    `Tem certeza que deseja pegar o cupom ${item.title} por ${item.value} pontos?`);
                if (!confimed) {
                    return;
                }
                item.loading = true;
                this.$store.dispatch("buyTicket", item.id).then(response => {
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                    this.$store.dispatch('getUserData');
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(() => {
                    item.loading = false;
                })
            }
        }
    }
</script>